module.exports = __webpack_public_path__ + "c7f385aef3cc4aca428633f94451ae97.mp3";